"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallbackRegistry = void 0;
class CallbackRegistry {
    static registry = new Map();
    static has(event) {
        return this.registry.has(event);
    }
    static set(event, func) {
        if (!this.registry.has(event)) {
            this.registry.set(event, []);
        }
        const funcs = this.registry.get(event);
        funcs.push(func);
        this.registry.set(event, funcs);
    }
    static get(event) {
        if (this.registry.has(event)) {
            return this.registry.get(event);
        }
        else {
            return [];
        }
    }
    static refresh() {
        this.registry = new Map();
    }
}
exports.CallbackRegistry = CallbackRegistry;
//# sourceMappingURL=callback.js.map